var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactoryCat10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.688,
    height: 30.066,
    viewBox: "0 0 30.688 30.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "factory_24dp_E8EAED_FILL1_wght300_GRAD0_opsz24",
    d: "M100-814.544v-18.071l9.691-4.121v3.2l8.076-3.246v4.473h12.921v17.767Zm13.915-6.026h2.857v-5.715h-2.857Zm-6.461,0h2.857v-5.715h-2.857Zm12.921,0h2.857v-5.715h-2.857Zm10.051-13.667H124.37l1.4-10.374h3.392Z",
    transform: "translate(-100 844.609)",
    fill: "#85899c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactoryCat10);
export default __webpack_public_path__ + "static/media/factory_cat_10.ffcdf9ebf00c0fd6793486c05f846c8a.svg";
export { ForwardRef as ReactComponent };